export enum RouteName {
  Goals = 'GoalsSummary',
  Overview = 'ConsumerOverview',
  Transactions = 'Transactions',
  Profile = 'Profile',
  MoneyGuidePro = 'MoneyGuidePro',
  CashFlowReport = 'ProjectedCashFlowReport',
  DocumentVault = 'DocumentVault',
  EMoney = 'EMoney',
  Schwab = 'Schwab',
  RISA = 'RISA',
  OrionTrading = 'OrionTrading',
  DataReconciliation = 'DataReconciliation',
  Newsfeed = 'Newsfeed',
  AssetBucketingResults = 'AssetBucketingResults',
  RightCapital = 'RightCapital',
  NetWorth = 'NetWorth',
  PulseCheckWorkflow = 'PulseCheckWorkflow',
  PulseCheckResults = 'PulseCheckResults',
  GoalTrack = 'GoalTrack',
  BeFi = 'BeFi',
  BeFi20Workflow = 'BeFi20Workflow',
  BeFi20Overview = 'BeFi20Overview',
}
